import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

// 引入三方组件库
import ElementUI from 'element-ui';
//  import 'element-ui/lib/theme-chalk/index.css';//el ui官方主题
import './assets/theme/green/index.css';//elementui 绿色主题
import Cookies from 'js-cookie'

import './assets/theme/echarts/shine'//echart主题

// 引用工具js
import api from './commonJs/http.js'
import util from './commonJs/util.js'
import base64 from './commonJs/base64.js'

// 导入全局样式表
import './assets/global/body.less'
import './assets/global/map.css'
import './assets/global/transition.css'
import './assets/icon/iconfont.css'
import './assets/global/table.css'
// import './assets/global/var.less'

//引用layer弹窗
import layer from './commonJs/layer/index'

import XLSX from 'xlsx'
Vue.prototype.XLSX = XLSX;

//element-ui组件
Vue.use(ElementUI);

// 将axios方法绑定到全局
Vue.prototype.$api = api;
//cookies
Vue.prototype.$Cookies = Cookies;
//将工具类方法绑定到全局
Vue.prototype.$util = util;
Vue.prototype.$base64 = base64;
Vue.prototype.$layer = layer(Vue);

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
